<template>
  <div>
    <div class="content_header">
      <v-toolbar flat color="white mx-2">
        <v-toolbar-title>
          <v-row>
            <v-col class="d-flex align-center">
              <img
                width="50px"
                class="mr-2 rounded-circle"
                src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/itowokashi.webp"
              >
              ラッシュデュエルラボ デッキ管理 ver1.51
            </v-col>
          </v-row>
        </v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-row>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" dark @click="editItem()">
              <v-icon>mdi-new-box</v-icon>デッキ新規追加
            </v-btn>
          </v-col>
        </v-row>
      </v-toolbar>
    </div>

    <v-card class="ma-6 pa-4" min-height="800">
      <!-- <v-row class="pl-8">
        <v-col cols="6">
          <v-radio-group v-model="search2" :custom-filter="customFilter" row>
            <v-radio
              v-for="(item, index) in deck_disp_sort_array"
              :key="index"
              :label="index"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="6">
          <v-radio-group v-model="search2" :custom-filter="customFilter" row>
            <v-radio
              v-for="(item, index) in c_legend_sort_array"
              :key="index"
              :label="index"
              :value="item"
            ></v-radio>
          </v-radio-group>
        </v-col>
      </v-row>-->

      <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
        <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
      </v-overlay>

      <v-text-field
        v-model="search2"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        id="data_search"
        class="mx-4 pa-4"
        placeholder="検索"
        @focus="searchTextFieldFocus"
        clearable
      ></v-text-field>

      <v-data-iterator
        :headers="headers"
        :items="deck_recipe_list"
        :search="search2"
        :items-per-page="100"
        :footer-props="{ itemsPerPageOptions: [100, 200, 500] }"
      >
        <template v-slot:default="props">
          <ul class="deck_list">
            <li v-for="item in props.items" :key="item.title" color style="border-radius:10px;">
              <SimpleCardDisp
                type="deck"
                :item="item"
                v-on:editItem="editItem"
                v-on:copyToClipboard="copyToClipboard"
                v-on:copyToClipboard2="copyToClipboard2"
              />
            </li>
          </ul>
        </template>
      </v-data-iterator>
    </v-card>

    <!-- 編集画面 -->
    <v-row justify="center">
      <v-dialog
        v-model="showDialog"
        scrollable
        persistent
        max-width="1500px"
        style="height: 95vh;"
        @click:outside="showDialog = false"
      >
        <v-card width="800" :disabled="loading">
          <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-4 ml-1" width="100%">
              <v-col cols="10">
                <div
                  v-if="target_item.id != ''"
                  v-html="checkUrl(target_item.url, target_item.name)"
                ></div>
                <div v-else>デッキを新規追加</div>
              </v-col>
              <v-col cols="2" class="text-right pr-5">
                <v-icon large color="blue darken-1" @click="closeDialog()">mdi-close-thick</v-icon>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row>
                <!-- 左のデッキ画像_S -->
                <v-col cols="2" class="mt-6 text-center">
                  <div
                    style="
                      position: relative; 
                      width:150px!important; 
                      margin-left: auto; 
                      margin-right: auto;"
                  >
                    <v-img
                      v-if="target_item.img != ''"
                      width="150"
                      :src="'https://appmedia.jp'+target_item.img"
                      style="outline: 1px solid #a9a9a9; border-radius: 2px;"
                    ></v-img>
                    <v-img
                      v-else
                      width="150"
                      src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/img/all_cards/no_image.webp"
                      style="outline: 1px solid #a9a9a9; border-radius: 2px;"
                    ></v-img>
                    <div
                      class="pa-1"
                      width="120"
                      height="120"
                      style="
                      position: absolute; 
                      bottom: 10px; 
                      right: 5px; 
                      background-color: #fff; 
                      border-radius: 10px; 
                      border: 1px solid #222; 
                      display: inline-flex;"
                    >
                      <v-img
                        loading="lazy"
                        src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/other/master_duel_deck.webp"
                        width="50"
                      ></v-img>
                    </div>
                  </div>
                  <div class="mt-6">
                    <v-autocomplete
                      v-model="target_item.img"
                      :items="target_recipe"
                      item-text="card_name"
                      item-value="card_img"
                      label="デッキ画像(カード画像)"
                      style="font-size: 12px!important;"
                    ></v-autocomplete>
                  </div>

                  <!-- <div
                    class="button_label_noimg2 white ml-1 mr-1 mt-1"
                    style="border: 2px solid #F44336 !important; color: #F44336 !important; border-radius: 10px;"
                    @click="copyToClipboard2(target_item, '')"
                  >
                    <span>
                      <v-icon color="red darken-1" size="30">mdi-alpha-s-box-outline</v-icon>ショートコード
                    </span>
                  </div>
                  <div
                    class="button_label_img2 white ml-1 mr-1 mt-2"
                    style="border: 2px solid #F44336 !important; color: #F44336 !important; border-radius: 10px;"
                    @click="copyToClipboard(target_item, 'img')"
                  >
                    <span>
                      <v-icon color="red darken-1" size="30">mdi-image-outline</v-icon>画像ありaタグ
                    </span>
                  </div>
                  <div
                    class="button_label_noimg2 white ml-1 mr-1 mt-2"
                    style="border: 2px solid #F44336 !important; background-color: #F44336 !important; color: #fff !important; border-radius: 10px;"
                    @click="copyToClipboard(target_item, '')"
                  >
                    <span>
                      <v-icon color="white" size="30">mdi-image-off</v-icon>画像なしaタグ
                    </span>
                  </div>-->

                  <a
                    :href="'https://admin.appmedia.jp/duel_links/'+target_item.url"
                    target="_blank"
                    v-if="target_item.url != ''"
                  >
                    <div
                      class="article_button white ml-1 mr-1 mt-4"
                      style="border: 2px solid #01579B !important; border-radius: 10px;"
                    >
                      <span>
                        <v-icon color="light-blue darken-4" size="30">mdi-eye-arrow-left-outline</v-icon>記事閲覧
                      </span>
                    </div>
                  </a>

                  <a
                    :href="'https://admin.appmedia.jp/wp-admin/post.php?post='+target_item.url+'&action=edit'"
                    target="_blank"
                    v-if="target_item.url != ''"
                  >
                    <div
                      class="article_button white ml-1 mr-1 mt-3"
                      style="border: 2px solid #01579B !important; border-radius: 10px;"
                    >
                      <span>
                        <v-icon color="light-blue darken-4" size="30">mdi-note-edit-outline</v-icon>記事編集
                      </span>
                    </div>
                  </a>
                </v-col>
                <!-- 左のデッキ画像_E -->
                <v-col cols="10">
                  <v-row>
                    <v-col cols="7">
                      <v-tabs center-active v-model="tab" class="pt-0">
                        <v-tab>基本情報</v-tab>
                        <v-tab>評価(ポイント)</v-tab>
                        <v-tab>評価(解説/簡易評価)</v-tab>
                        <v-tab>レシピ編集</v-tab>
                      </v-tabs>
                    </v-col>
                  </v-row>
                  <v-tabs-items v-model="tab" class="pt-0">
                    <v-tab-item class="deck_tab">
                      <v-row>
                        <v-col cols="2">
                          <v-text-field
                            label="デッキID(変更不可)"
                            hide-details="auto"
                            v-model="target_item.id"
                            disabled
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-select
                            label="一覧表示/非表示"
                            :items="display_flg_arr"
                            v-model="target_item.display_flg"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field
                            label="デッキ名"
                            hide-details="auto"
                            :rules="rules"
                            v-model="target_item.name"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="2">
                          <v-text-field
                            label="個別記事URL(記事番号のみ)"
                            hide-details="auto"
                            v-model="target_item.url"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-autocomplete
                            v-model="target_evaluation_type_array['strength']"
                            :items="evaluation_st_array"
                            label="デッキの強さ"
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-autocomplete
                            v-model="target_evaluation_type_array['type']"
                            :items="evaluation_ty_array"
                            label="タイプ"
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-autocomplete
                            v-model="target_evaluation_type_array['difficulty1']"
                            :items="evaluation_df_array"
                            label="運用難度"
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-autocomplete
                            v-model="target_evaluation_type_array['difficulty2']"
                            :items="evaluation_df_array"
                            label="構築難度"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="6">
                          <v-autocomplete
                            v-model="need_getdata['パック']"
                            :items="packdata['パック']"
                            item-text="name"
                            item-value="id"
                            chips
                            label="必須パック"
                            multiple
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                          <v-autocomplete
                            v-model="need_getdata['ストラク']"
                            :items="packdata['ストラク']"
                            item-text="name"
                            item-value="id"
                            chips
                            label="必須ストラク"
                            multiple
                          ></v-autocomplete>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-text-field
                            label="デッキ画像(サムネイル画像/wp-content〜)"
                            hide-details="auto"
                            v-model="target_item.deck_thumbnail"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- ポイント_S -->
                    <v-tab-item class="deck_tab">
                      <v-row>
                        <v-col cols="8">
                          <v-row>
                            <v-col>
                              <v-textarea
                                :rows="3"
                                class="custom_textarea"
                                auto-grow
                                outlined
                                v-model="target_evaluation_txt_array['point1']"
                                label="ポイント1"
                                counter="200"
                                style="font-size: 13px!important;"
                                @input="textChange('eva1', target_evaluation_txt_array['point1'])"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                :rows="3"
                                class="custom_textarea"
                                auto-grow
                                outlined
                                v-model="target_evaluation_txt_array['point2']"
                                label="ポイント2"
                                counter="200"
                                style="font-size: 13px!important;"
                                @input="textChange('eva2', target_evaluation_txt_array['point2'])"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                :rows="3"
                                class="custom_textarea"
                                auto-grow
                                outlined
                                v-model="target_evaluation_txt_array['point3']"
                                label="ポイント3"
                                counter="200"
                                style="font-size: 13px!important;"
                                @input="textChange('eva3', target_evaluation_txt_array['point3'])"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4">
                          <HtmlPreview
                            :evaluation="'<ul><li>'+target_preview.eva1+'</li><li>'+target_preview.eva2+'</li><li>'+target_preview.eva3+'</li></ul>'"
                            :add_html="points_thml1+target_item.name+points_thml2"
                          ></HtmlPreview>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- ポイント_E -->
                    <!-- simple_eva_S -->
                    <v-tab-item class="deck_tab">
                      <v-row>
                        <v-col cols="8">
                          <v-row>
                            <v-col>
                              <v-textarea
                                :rows="8"
                                class="custom_textare"
                                auto-grow
                                outlined
                                v-model="target_evaluation_txt_array['concept']"
                                label="コンセプト"
                                counter="500"
                                style="font-size: 14px!important;"
                                @input="textChange('eva4', target_evaluation_txt_array['concept'])"
                              ></v-textarea>
                              <div class="remarks_txt">＊改行をしたい場合はエンターで改行。brタグは不要です</div>
                              <div class="remarks_txt">＊記事ではh3タグで「〜デッキのコンセプト」が入るので重複しないように注意！</div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-textarea
                                :rows="3"
                                class="custom_textare"
                                auto-grow
                                outlined
                                v-model="target_evaluation_txt_array['simple_eva']"
                                label="簡易評価"
                                counter="500"
                                style="font-size: 14px!important;"
                                @input="textChange('eva5', target_evaluation_txt_array['simple_eva'])"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4">
                          <HtmlPreview
                            :evaluation="target_preview.eva4"
                            :add_html="'<h3>'+target_item.name+'デッキのコンセプト</h3>'"
                          ></HtmlPreview>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- simple_eva_E -->
                    <!-- デッキ情報編集画面_S -->
                    <v-tab-item class="deck_tab">
                      <v-row>
                        <v-col cols="6">
                          <v-text-field
                            label="追加したいレシピ名を入力"
                            hide-details="auto"
                            v-model="new_recipe_name"
                            :style="{ width: '70%' ,display: 'inline-block'}"
                          ></v-text-field>
                          <v-btn
                            color="green"
                            dark
                            class="mb-2"
                            @click="addRecipeName()"
                            :style="{ width: '30%' ,display: 'inline-block'}"
                          >
                            <v-icon>mdi-plus-thick</v-icon>追加
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <v-card class="ma-6">
                            <v-data-table
                              :headers="headers2"
                              :items="deck_name_array"
                              :search="search"
                              item-key="name"
                              :items-per-page="20"
                              :footer-props="{ itemsPerPageOptions: [20, 40, 60, -1] }"
                            >
                              <template v-slot:item="{ item }">
                                <tr :class="DefaultRecipeChecked(item.default_recipe)">
                                  <td class="text-center" width="20%">
                                    <div class="d-flex justify-center">
                                      <v-radio-group v-model="recipe_radio">
                                        <v-radio :value="item.recipe_name" name="radioGroup"></v-radio>
                                      </v-radio-group>
                                    </div>
                                  </td>
                                  <td class="align-left" width="80%" @click="editRecipe(item)">
                                    <div text>{{ item.recipe_name }}</div>
                                  </td>
                                </tr>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-col>
                      </v-row>
                      <v-row class="ml-3">
                        <v-col cols="12">
                          <div class="remarks_txt">
                            ＊「表示レシピ」の設定は必須です。
                            <br>表示レシピに設定されたレシピが削除された場合、別のレシピが自動で表示レシピに設定されるので注意してください。
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <!-- デッキ情報編集画面_E -->
                  </v-tabs-items>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="blue darken-1" text @click="closeDialog()">閉じる</v-btn>
            <v-row class="pa-4 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="blue" dark @click="saveItem('')">更新</v-btn>
              </v-col>
              <v-col cols="12" style="max-width:120px;text-align:right;">
                <v-btn color="red" dark @click="saveItem('delete')">削除</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- レシピ編集画面 -->
    <v-row justify="center">
      <v-dialog
        v-model="showDialog2"
        scrollable
        persistent
        max-width="1500px"
        style="height: 95vh;"
      >
        <v-card width="800" :disabled="loading">
          <v-overlay color="grey lighten-2" :absolute="true" :value="loading">
            <v-progress-circular :size="70" :width="7" color="yellow darken-4" indeterminate></v-progress-circular>
          </v-overlay>

          <v-card-title class="pa-0">
            <v-row class="pa-2 ml-1" style="width:100%">
              <v-col cols="10" style="display:table;">
                <div
                  style="display:table-cell; vertical-align:middle; text-align:left; width: 40px;"
                >レシピ編集</div>
              </v-col>
              <v-col cols="2" class="text-right">
                <v-btn color="blue darken-1" text @click="closeDialog2()" style="font-size:40px;">×</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <div class="contents">
              <v-row class="pa-2">
                <!-- レシピ表示_S -->
                <v-col cols="6" class="pt-2 pb-2 pl-0 pr-0">
                  <v-row class="pr-4 pl-4 ml-1 mb-2" justify="center">
                    <v-col
                      cols="8"
                      style="display:flex; justify-content:center; align-items:center;"
                    >
                      <v-text-field
                        dense
                        label="レシピ名編集"
                        hide-details="auto"
                        class="label_small"
                        v-model="edit_deck_recipe_name"
                        :style="{ width: '70%' ,display: 'inline-block', 'font-size': '14px', 'width': '20%'}"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="4">
                      <span>
                        <span class="font-weight-bold">LEGEND</span>
                        ：{{ target_leg_card }}枚
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" class="text-center">
                      <v-img
                        width="25px"
                        src="https://appmedia.jp/wp-content/uploads/2021/11/decks.png"
                        class="mx-auto"
                      ></v-img>
                      <div class="card_cnt_lbl">{{ target_all_card }}枚</div>
                    </v-col>
                    <v-col cols="3" class="text-center">
                      <v-img
                        width="20px"
                        src="https://appmedia.jp/wp-content/uploads/2021/11/monster.png"
                        class="mx-auto"
                      ></v-img>
                      <div class="card_cnt_lbl">{{ target_mon_card }}枚</div>
                    </v-col>
                    <v-col cols="3" class="text-center">
                      <v-img
                        width="20px"
                        src="https://appmedia.jp/wp-content/uploads/2021/11/magic.png"
                        class="mx-auto"
                      ></v-img>
                      <div class="card_cnt_lbl">{{ target_mag_card }}枚</div>
                    </v-col>
                    <v-col cols="3" class="text-center">
                      <v-img
                        width="20px"
                        src="https://appmedia.jp/wp-content/uploads/2021/11/trap.png"
                        class="mx-auto"
                      ></v-img>
                      <div class="card_cnt_lbl">{{ target_tra_card }}枚</div>
                    </v-col>
                  </v-row>
                  <!-- ノーマルデッキ_S -->
                  <draggable
                    class="deck_list2 amber lighten-5 pa-3"
                    tag="ul"
                    v-model="target_recipe_separate['nomal']"
                  >
                    <li
                      v-for="(item, index) in target_recipe_separate['nomal']"
                      :key="index"
                      class="text-center card_list_item pl-1 pr-1"
                    >
                      <div
                        @click="delRecipeCard(item)"
                        style="position: relative; width:50px!important; margin-left: auto; margin-right: auto;"
                      >
                        <v-img
                          width="50"
                          height="72.5"
                          :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/' + item.card_id + '.webp'"
                        ></v-img>
                        <v-img
                          v-if="item.limit_data == '禁止'"
                          loading="lazy"
                          src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/kinshi.png"
                          width="20"
                          height="20"
                          style="position: absolute; top:0px; left:0px; background-color: #222; border-radius: 30px;"
                        ></v-img>
                        <div v-if="item.limit_data == 'リミット3'" class="deck_limit">3</div>
                        <div v-if="item.limit_data == 'リミット2'" class="deck_limit">2</div>
                        <div v-if="item.limit_data == 'リミット1'" class="deck_limit">1</div>
                        <div v-if="item.legend == 'LEGEND'" class="legend">L</div>
                      </div>
                      <div class="card_name2" style="color:#222!important;">{{ item.card_name }}</div>
                    </li>
                  </draggable>
                  <!-- ノーマルデッキ_E -->
                  <!-- エクストラデッキ_S -->
                  <v-row class="mt-5 mb-3">
                    <v-col cols="12" class="text-center pb-0">
                      <span class="card_cnt_lbl_ex">EX</span>
                      <br>
                      <span class="card_cnt_lbl">{{ target_ex_card }}枚</span>
                    </v-col>
                  </v-row>
                  <draggable
                    class="deck_list2 deep-purple lighten-5 pa-3"
                    tag="ul"
                    v-model="target_recipe_separate['ex']"
                  >
                    <li
                      v-for="(item, index) in target_recipe_separate['ex']"
                      :key="index"
                      class="text-center card_list_item pl-1 pr-1"
                    >
                      <div
                        @click="delRecipeCard(item)"
                        style="position: relative; width:50px!important; margin-left: auto; margin-right: auto;"
                      >
                        <v-img
                          width="50"
                          height="72.5"
                          :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/' + item.card_id + '.webp'"
                        ></v-img>
                        <v-img
                          v-if="item.limit_data == '禁止'"
                          loading="lazy"
                          src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/kinshi.png"
                          width="20"
                          height="20"
                          style="position: absolute; top:0px; left:0px; background-color: #222; border-radius: 30px;"
                        ></v-img>
                        <div v-if="item.limit_data == 'リミット3'" class="deck_limit">3</div>
                        <div v-if="item.limit_data == 'リミット2'" class="deck_limit">2</div>
                        <div v-if="item.limit_data == 'リミット1'" class="deck_limit">1</div>
                        <div v-if="item.legend == 'LEGEND'" class="legend">L</div>
                      </div>
                      <div class="card_name2" style="color:#222!important;">{{ item.card_name }}</div>
                    </li>
                  </draggable>
                  <!-- エクストラデッキ_E -->
                </v-col>
                <!-- レシピ表示_E -->
                <!-- カード一覧_S -->
                <v-col cols="6" class="pt-2 pb-2 pl-0 pr-0">
                  <v-card class="ma-2">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      id="data_search"
                      class="mx-4 pa-4"
                      placeholder="検索"
                      clearable
                    ></v-text-field>

                    <v-data-iterator
                      :headers="headers"
                      :items="list"
                      :search="search"
                      :custom-filter="customFilter"
                      :items-per-page="50"
                      :footer-props="{ itemsPerPageOptions: [40, 100, 500] }"
                    >
                      <template v-slot:default="props">
                        <ul class="deck_list2" style="overflow: scroll;">
                          <li
                            v-for="item in props.items"
                            :key="item.id"
                            class="text-center card_list_item pl-1 pr-1"
                            color
                          >
                            <div>
                              <div
                                @click="addRecipe(item)"
                                style="position: relative; width:50px!important; margin-left: auto; margin-right: auto;"
                              >
                                <v-img
                                  width="50"
                                  height="72.5"
                                  :src="'https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/'+item.id+'.webp'"
                                ></v-img>
                                <v-img
                                  v-if="item.limit_data == '禁止'"
                                  loading="lazy"
                                  src="https://appmedia.jp/wp-content/themes/appmedia/lib/yugioh/yugioh_md_img/other/kinshi.png"
                                  width="20"
                                  height="20"
                                  style="position: absolute; top:0px; left:0px; background-color: #222; border-radius: 30px;"
                                ></v-img>
                                <div v-if="item.limit_data == 'リミット3'" class="deck_limit">3</div>
                                <div v-if="item.limit_data == 'リミット2'" class="deck_limit">2</div>
                                <div v-if="item.limit_data == 'リミット1'" class="deck_limit">1</div>
                                <div v-if="item.legend == 'LEGEND'" class="legend">L</div>
                              </div>
                            </div>
                            <div class="card_name2">{{ item.name }}</div>
                          </li>
                        </ul>
                      </template>
                    </v-data-iterator>
                  </v-card>
                </v-col>
                <!-- カード一覧_E -->
              </v-row>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="light-blue darken-4" text @click="closeDialog2()">レシピ編集を閉じる</v-btn>
            <v-row class="pa-4 ml-1" align="center" style>
              <v-col style="max-width:120px;text-align:right;">
                <v-btn color="light-blue darken-4" dark @click="saveRecipe('')">レシピ更新</v-btn>
              </v-col>
              <v-col cols="12" style="max-width:120px;text-align:right;">
                <v-btn
                  v-if="target_post_type2 != 'insert'"
                  color="deep-orange accent-4"
                  dark
                  @click="saveRecipe('delete')"
                >レシピ削除</v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
      {{ snackbarText }}
      <v-btn color="white" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
// Ajax通信ライブラリ
import axios from "axios";

// コンポーネント
import draggable from "vuedraggable";
import SimpleCardDisp from "./components/SimpleCardDisp.vue";
import HtmlPreview from "./components/HtmlPreview.vue";

// 定数
import { Config } from "./constants/constants.js";

// 共通関数
import { insertHtmlTag } from "./constants/constants.js";
import { delHtmlTag } from "./constants/constants.js";

export default {
  components: {
    // ドラッグアンドドロップ
    draggable,
    // デッキ表示(一覧)
    SimpleCardDisp,
    // 評価プレビュー
    HtmlPreview
  },

  data() {
    return {
      // disp_type: ["一覧非表示","完全非表示"],

      snackbar: false,
      snackbarText: "",
      snackbarColor: "info",
      timeout: 2000,

      dialog: false,
      confirm_dialog: false,
      overlay: false,

      showDialog: false,
      showDialog2: false,

      loading: false,

      tab: null,

      deck_recipe_list: [],

      all_getdata: {},
      packdata: {},

      display_flg_arr: ["表示", "非表示"],

      need_getdata: { パック: [], ストラク: [] },

      deck_disp_sort_array: Config.deck_disp_sort_array,
      evaluation_st_array: Config.evaluation_st,
      evaluation_ty_array: Config.evaluation_ty,
      evaluation_df_array: Config.evaluation_df,

      target_item: {},
      deck_data_cols: [],

      target_evaluation_txt_array: {
        point1: "",
        point2: "",
        point3: "",
        concept: "",
        simple_eva: ""
      },

      target_evaluation_type_array: {
        strength: "",
        type: "",
        difficulty1: "",
        difficulty2: ""
      },

      // 新規/更新/削除 判定
      target_post_type: "", // 基本情報
      target_post_type2: "", // レシピ

      target_default_deck_edit_flg: false,

      // レシピ名系
      new_recipe_name: "",
      target_deck_recipe_name: "",
      befor_recipe_name: "",
      edit_deck_recipe_name: "",

      // デッキレシピ一覧配列
      deck_name_array: [],

      // デッキレシピに追加した時のカード順番
      deck_recipe_card_id: 0,
      // 変更後のレシピ(通常、EXで分けない配列。デッキ画像選択に使用する)
      target_recipe: [],
      // 変更後のレシピ(通常、EXで分けた配列)
      target_recipe_separate: {},
      // 変更前のレシピ
      befor_recipe_separate: {},

      // カード枚数カウント
      target_all_card: 0,
      target_mon_card: 0,
      target_mag_card: 0,
      target_tra_card: 0,
      target_ex_card: 0,
      target_leg_card: 0,

      rules: [value => !!value || "入力必須"],

      // //検索用パラメータ
      search: "",
      search2: "",

      target_preview: { eva1: "", eva2: "", eva3: "", eva4: "", eva5: "" },

      points_thml1: "<div class='checklists'><p><strong>【",
      points_thml2: "デッキの注目ポイント】</strong></p>",

      headers: [],
      headers2: [
        {
          text: "表示ﾚｼﾋﾟ",
          align: "center",
          value: "default_recipe",
          sortable: false,
          width: "20%"
        },
        {
          text: "レシピ名",
          value: "recipe_name",
          width: "80%",
          align: "center"
        }
      ],

      recipe_radio: "",

      list: [],
      list2: [],
      card_by_id: {},

      // // 入力規則
      required: value => !!value || "必ず入力してください" // 入力必須の制約
    };
  },

  computed: {},

  //---------------------------
  // 読み込み時に実行
  //---------------------------
  created: function() {
    this.loading = true;
    // console.log(const_array);
    // カード一覧
    this.getCardList();
    // デッキレシピ一覧
    this.getDeckRecipeList();
    // 入手方法データ取得
    this.getGetMaster();
    // デッキデータテーブルのカラムを取得
    this.getDeckCols();
    this.loading = false;
  },

  methods: {
    customFilter: function(items, search) {
      if (search === null || search == "") {
        return items;
      }
      items = items.filter(function(value) {
        if (value.name.indexOf(search) != -1) {
          return true;
        } else if (value.name_kana.indexOf(search) != -1) {
          return true;
        } else if (value.name.indexOf(search) != -1) {
          return true;
        } else {
          return false;
        }
      });
      return items;
    },

    searchTextFieldFocus() {
      this.search = "";
    },

    //---------------------------
    // スナックバー
    // わざわざalertで出さなくてもいいかなって時に
    //---------------------------
    showSnackbar(text) {
      this.snackbarText = text;
      this.snackbar = true;
    },

    handleScroll(event) {
      // スクロールイベントが発生した場合、列の位置を調整
      const fixedColumn = document.querySelector(".fix_col");
      if (fixedColumn) {
        fixedColumn.style.left = `${event.target.scrollLeft}px`;
      }
    },

    //---------------------------
    // カードリスト取得
    //---------------------------
    getCardList() {
      axios.get(process.env.VUE_APP_RD_CARD_LIST_LIGHT_VER).then(response => {
        const items = [];
        const items2 = {};
        const values = Object.values(response.data);

        values.forEach(value => {
          items.push(value);
          items2[value.id] = value;
        });
        this.list = items;
        this.card_by_id = items2;
      });
    },

    //---------------------------
    // デッキリスト取得
    //---------------------------
    getDeckRecipeList() {
      axios.get(process.env.VUE_APP_RD_DECK_LIST).then(response => {
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          items.push(value);
        });
        this.deck_recipe_list = items;
      });
    },

    //---------------------------
    // デッキのレシピ名取得
    //---------------------------
    getDeckRecipeNameList(item) {
      this.recipe_radio = "";
      axios
        .get(process.env.VUE_APP_RD_DECK_RECIPE_NAME_LIST, {
          params: { id: item.id }
        })
        .then(response => {
          const items = [];
          const values = Object.values(response.data);
          values.forEach(value => {
            // デフォルトレシピか判断
            const def_rec =
              value == this.target_item.disp_recipe_name ? true : false;

            if (def_rec == true) {
              this.recipe_radio = value;
            }

            const tmp_arr = {
              default_recipe: def_rec,
              recipe_name: value,
              new_recipe_flg: false
            };
            items.push(tmp_arr);
          });
          this.deck_name_array = items;
          this.deck_name_array;

          // console.log(this.deck_name_array);
          // console.log(this.recipe_radio);
        });
    },

    //---------------------------
    // 入手方法取得
    //---------------------------
    getGetMaster() {
      axios.get(process.env.VUE_APP_RD_GETMASTER_LIST).then(response => {
        const items = {};
        const items2 = {};
        const values = Object.values(response.data);

        values.forEach(value => {
          if (value.type != "パック" && value.type != "ストラク") {
            return true;
          }
          if (typeof items[value.id] == "undefined") {
            items[value.id] = value;
          }

          if (typeof items2[value.type] == "undefined") {
            items2[value.type] = [];
          }
          items2[value.type].push(value);
        });
        this.all_getdata = items;
        this.packdata = items2;
        // console.log(this.all_getdata);
      });
    },

    //---------------------------
    // 評価テキスト変更時
    //---------------------------
    textChange(target_key, preview_html) {
      // console.log(preview_html);
      if (
        target_key == "eva1" ||
        target_key == "eva2" ||
        target_key == "eva3"
      ) {
        this.target_preview[target_key] = preview_html;
      } else {
        this.target_preview[target_key] = insertHtmlTag(preview_html);
      }
    },

    //---------------------------
    // デッキ基本情報編集画面
    //---------------------------
    editItem(item) {
      this.need_getdata = { パック: [], ストラク: [] };
      this.new_recipe_name = "";
      if (typeof item != "undefined") {
        var tmp_evaluation_txt = {};
        try {
          tmp_evaluation_txt = JSON.parse(item.evaluation_txt);
        } catch (error) {
          tmp_evaluation_txt = {
            point1: "",
            point2: "",
            point3: "",
            concept: "",
            simple_eva: ""
          };
          console.log("evaluation_txt:" + error);
        }

        var tmp_evaluation_type = {};
        try {
          tmp_evaluation_type = JSON.parse(item.evaluation_type);
        } catch (error) {
          tmp_evaluation_type = {
            point1: "",
            point2: "",
            point3: "",
            concept: "",
            simple_eva: ""
          };
          console.log("evaluation_type:" + error);
        }

        // item(取得したカードデータ)をターゲット配列にコピー
        this.target_item = Object.assign({}, item);

        // デフォルトのレシピが設定されていればあらかじめ表示
        if (
          typeof item.disp_recipe_name !== "undefined" &&
          item.disp_recipe_name != ""
        ) {
          this.target_deck_recipe_name = item.disp_recipe_name;
        }

        // 設定されているデッキレシピのみ取得
        this.getDefaultDeckRecipe();

        // this.target_item.needed_pack = item.needed_pack.split(",");

        var tmp_target_getdata = item.needed_pack.split(",");

        tmp_target_getdata.forEach(value => {
          if (
            typeof this.all_getdata[value] != "undefined" &&
            Object.keys(this.all_getdata[value]).length > 0
          ) {
            const tmp_type = this.all_getdata[value].type;
            if (typeof this.need_getdata[tmp_type] == "undefined") {
              this.need_getdata[tmp_type] = [];
            }
            this.need_getdata[tmp_type].push(value);
          }
        });

        // all_getdata

        this.target_evaluation_txt_array = tmp_evaluation_txt;
        this.target_evaluation_type_array = tmp_evaluation_type;

        this.target_preview["eva1"] = this.target_evaluation_txt_array.point1;
        this.target_preview["eva2"] = this.target_evaluation_txt_array.point2;
        this.target_preview["eva3"] = this.target_evaluation_txt_array.point3;

        this.target_preview["eva4"] = this.target_evaluation_txt_array.concept;
        this.target_evaluation_txt_array.concept = delHtmlTag(
          this.target_evaluation_txt_array.concept
        );
        this.target_preview[
          "eva5"
        ] = this.target_evaluation_txt_array.simple_eva;
        this.target_evaluation_txt_array.simple_eva = delHtmlTag(
          this.target_evaluation_txt_array.simple_eva
        );

        if (item.display_flg == "" || item.display_flg == 0) {
          this.target_item.display_flg = "表示";
        } else if (item.display_flg == 1) {
          this.target_item.display_flg = "非表示";
        }

        // 全レシピ名取得
        this.getDeckRecipeNameList(item);

        this.target_post_type = "update";
      } else {
        // ターゲット配列を初期化
        this.deck_data_cols.forEach(value => {
          this.target_item[value] = "";
        });

        this.target_evaluation_txt_array = {
          point1: "",
          point2: "",
          point3: "",
          concept: "",
          simple_eva: ""
        };
        this.target_evaluation_type_array = {
          strength: "",
          type: "",
          difficulty1: "",
          difficulty2: ""
        };
        this.target_display_flg = 0;

        this.target_deck_recipe_name = "";
        this.edit_deck_recipe_name = "";
        this.befor_recipe_name = "";
        this.new_recipe_name = "";

        this.need_getdata = { パック: [], ストラク: [] };

        this.target_recipe = [];
        this.deck_name_array = [];

        this.points_thml = "";

        this.target_post_type = "insert";
      }

      // this.recipeCnt();

      this.showDialog = true;
    },

    //---------------------------
    // aタグ(個別記事に飛ぶ用)
    //---------------------------
    checkUrl(url, txt) {
      if (url == "" || url == null) {
        return "<span>《" + txt + "デッキ》を編集中</span>";
      } else {
        return (
          "<span>《<a href='https://admin.appmedia.jp/duel_links/" +
          url +
          "' target='_blank'>" +
          txt +
          "デッキ</a>》を編集中</span>"
        );
      }
    },

    //---------------------------
    // デフォルトに設定されたレシピの
    // trを強調
    //---------------------------
    DefaultRecipeChecked(recipe_flg) {
      if (recipe_flg == true) {
        return "blue lighten-4";
      } else {
        return "";
      }
    },

    //---------------------------
    // デッキデータテーブルのカラム取得
    //---------------------------
    getDeckCols() {
      axios.get(process.env.VUE_APP_RD_DECK_COLS).then(response => {
        const items = [];
        const values = Object.values(response.data);
        values.forEach(value => {
          items.push(value.cols);
        });

        this.deck_data_cols = items;
      });
    },

    //---------------------------
    // レシピ名追加
    //---------------------------
    addRecipeName() {
      if (this.target_item.id == "") {
        alert("デッキを保存してからレシピを作成してください。");
        return;
      }

      if (this.new_recipe_name == "") {
        alert("レシピ名を入力してください。");
        return;
      }

      // 今回追加したレシピしかない場合はデフォルトレシピに自動設定
      var def_rec = false;
      if (
        typeof this.deck_name_array == "undefined" ||
        this.deck_name_array.length < 1
      ) {
        this.target_item.disp_recipe_name = this.new_recipe_name;
        def_rec = true;
        this.recipe_radio = this.new_recipe_name;
      }

      const tmp_arr = {
        default_recipe: def_rec,
        recipe_name: this.new_recipe_name,
        new_recipe_flg: true
      };

      this.deck_name_array.push(tmp_arr);

      this.showSnackbar("「" + this.new_recipe_name + "」を追加しました！");

      this.new_recipe_name = "";
    },

    //---------------------------
    // デフォルトのレシピに含まれる全カード取得
    // デッキ画像設定用配列
    //---------------------------
    getDefaultDeckRecipe() {
      axios
        .get(process.env.VUE_APP_RD_DECK_RECIPE_DATA, {
          params: {
            id: this.target_item.id,
            name: this.target_deck_recipe_name
          }
        })
        .then(response => {
          const items = [];
          const values = Object.values(response.data);
          var c_cnt = 0;

          values.forEach(value => {
            const tmp = {
              id: c_cnt,
              card_id: value.card_id,
              card_name: value.card_name,
              deck_id: value.deck_id,
              limit_data: this.card_by_id[Number(value.card_id)]["limit_data"],
              legend: this.card_by_id[Number(value.card_id)]["legend"],
              monster_type2: this.card_by_id[Number(value.card_id)][
                "monster_type2"
              ],
              recipe_name: value.recipe_name,
              card_img:
                "/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/" +
                value.card_id +
                ".webp"
            };

            items.push(tmp);
            c_cnt++;
          });

          this.target_recipe = items;

          this.recipeCnt();
        });
    },

    //---------------------------
    // デッキ基本情報更新
    //---------------------------
    saveItem(edit_type) {
      if (this.target_item.name == "" || this.target_item.name == null) {
        alert("デッキ名を入力してください");
        return;
      }

      // if (
      //   this.target_item.disp_recipe_name == "" ||
      //   this.target_item.disp_recipe_name == null
      // ) {
      //   alert("デッキ名(表示名)を入力してください");
      //   return;
      // }

      // if (this.target_item.img == "" || this.target_item.img == null) {
      //   alert("デッキ画像を指定してください");
      //   return;
      // }

      if (edit_type == "delete") {
        this.target_post_type = "delete";
      }

      var msg = "";
      if (this.target_post_type == "insert") {
        msg = "新規登録";
      } else if (this.target_post_type == "update") {
        msg = "更新";
      } else if (this.target_post_type == "delete") {
        msg = "削除";
      } else {
        alert("予期せぬエラーが発生しました。error code: post_type is empty");
        return;
      }
      if (
        !window.confirm(
          "《" +
            this.target_item.name +
            "》を" +
            msg +
            "します。よろしいですか？"
        )
      ) {
        return;
      }

      this.loading = true;

      var item = {};

      // 表示レシピが変更されているか
      if (this.target_item.disp_recipe_name != this.recipe_radio) {
        this.target_item.disp_recipe_name = this.recipe_radio;
      }

      // ターゲット配列をphpに投げる
      var tmp_get_arr = [];
      this.deck_data_cols.forEach(value => {
        var tmp_data = "";
        if (value == "needed_pack") {
          // if (this.target_item[value] != "") {
          //   tmp_data = this.target_item[value].join(",");
          // }
          tmp_get_arr = this.need_getdata["パック"].concat(
            this.need_getdata["ストラク"]
          );
          tmp_data = tmp_get_arr.join(",");
          console.log(tmp_get_arr);
        } else if (value == "id") {
          tmp_data = Number(this.target_item[value]);
        } else if (value == "display_flg") {
          if (this.target_item[value] == "表示") {
            tmp_data = 0;
          } else if (this.target_item[value] == "非表示") {
            tmp_data = 1;
          }
        } else if (value == "evaluation_txt") {
          this.target_evaluation_txt_array.concept = insertHtmlTag(
            this.target_evaluation_txt_array.concept
          );
          this.target_evaluation_txt_array.simple_eva = insertHtmlTag(
            this.target_evaluation_txt_array.simple_eva
          );
          tmp_data = JSON.stringify(this.target_evaluation_txt_array);
        } else if (value == "evaluation_type") {
          tmp_data = JSON.stringify(this.target_evaluation_type_array);
        } else {
          tmp_data = this.target_item[value];
        }

        item[value] = tmp_data;
      });

      item.post_type = this.target_post_type;

      console.log(item);

      axios
        .post(process.env.VUE_APP_RD_DECK_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("《" + this.target_item.name + "》を" + msg + "しました！");
          this.showDialog = false;
          this.getDeckRecipeList();
          this.recipeCnt();
        })
        .catch(error => {
          alert(
            "《" +
              this.target_item.name +
              "》の" +
              msg +
              "に失敗しました。\nエンジニアまでご連絡ください。\nerror code: " +
              error
          );
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //---------------------------
    // レシピ編集画面
    //---------------------------
    editRecipe(item) {
      this.new_recipe_name = "";
      this.target_deck_recipe_name = item.recipe_name;
      if (typeof item != "undefined") {
        this.getDeckRecipe();

        this.befor_recipe_name = item.recipe_name;
      } else {
        this.befor_recipe_name = "";
      }

      if (item.new_recipe_flg == true) {
        this.target_post_type2 = "insert";
      } else {
        this.target_post_type2 = "update";
      }

      // 開いたレシピがデフォルトレシピかどうか
      // デフォルトレシピの場合は、レシピ名が変更された場合は基本情報テーブルの更新が必要なので
      // 変数に格納しておく
      this.target_default_deck_edit_flg = item.default_recipe;

      this.recipeCnt();

      this.showDialog2 = true;
    },

    //---------------------------
    // レシピ取得(レシピ編集画面)
    //---------------------------
    getDeckRecipe() {
      axios
        .get(process.env.VUE_APP_RD_DECK_RECIPE_DATA, {
          params: {
            id: this.target_item.id,
            name: this.target_deck_recipe_name
          }
        })
        .then(response => {
          // const items = [];
          const items2 = {};
          const items3 = {};
          const values = Object.values(response.data);
          var c_cnt = 0;
          var deck_key = "";

          values.forEach(value => {
            const tmp = {
              id: c_cnt,
              card_id: value.card_id,
              card_name: value.card_name,
              attr: this.card_by_id[Number(value.card_id)]["attr"],
              deck_id: value.deck_id,
              limit_data: this.card_by_id[Number(value.card_id)]["limit_data"],
              legend: this.card_by_id[Number(value.card_id)]["legend"],
              monster_type2: this.card_by_id[Number(value.card_id)][
                "monster_type2"
              ],
              recipe_name: value.recipe_name,
              card_img:
                "/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/" +
                value.card_id +
                ".webp"
            };

            // 通常デッキとEXデッキ分ける
            if (tmp["monster_type2"] == "フュージョン") {
              deck_key = "ex";
            } else {
              deck_key = "nomal";
            }

            if (typeof items2[deck_key] === "undefined") {
              items2[deck_key] = [];
            }
            items2[deck_key].push(tmp);

            // なぜか更新後の配列の内容になってしまうので分離
            // (アドレス参照になり、どっちの配列も同期されてしまう)
            if (typeof items3[deck_key] === "undefined") {
              items3[deck_key] = [];
            }
            items3[deck_key].push(tmp);

            c_cnt++;
          });

          this.target_recipe_separate = items2;
          this.befor_recipe_separate = items3;

          this.deck_recipe_card_id = c_cnt;
          this.edit_deck_recipe_name = this.target_deck_recipe_name;
          this.befor_recipe_name = this.target_deck_recipe_name;

          this.recipeCnt();
        });
    },

    //---------------------------
    // レシピ追加
    //---------------------------
    addRecipe(item) {
      if (this.target_deck_recipe_name == "") {
        alert("レシピ名を選択するか、新規でレシピ名を追加してください。");
        return;
      }

      var deck_key = "";
      if (item["monster_type2"] == "フュージョン") {
        deck_key = "ex";
      } else {
        deck_key = "nomal";
      }

      // カード枚数チェック
      if (typeof this.target_recipe_separate[deck_key] !== "undefined") {
        var card_limit_cnt = 1;
        this.target_recipe_separate[deck_key].forEach(value => {
          if (value.card_id == item.id) {
            card_limit_cnt++;
          }
        });
        if (card_limit_cnt > 3) {
          alert("同名カードは3枚までです！");
          return;
        }
      }

      // 独自のカードidカウントアップ
      this.deck_recipe_card_id = this.deck_recipe_card_id + 1;

      const tmp = {
        id: this.deck_recipe_card_id,
        card_id: item.id,
        card_name: item.name,
        attr: item.attr,
        monster_type2: item.monster_type2,
        deck_id: this.target_item.id,
        limit_data: this.card_by_id[Number(item.id)]["limit_data"],
        legend: this.card_by_id[Number(item.id)]["legend"],
        recipe_name: this.target_deck_recipe_name,
        card_img:
          "/wp-content/themes/appmedia/lib/yugioh/yugioh_rd_img/" +
          item.id +
          ".webp"
      };

      if (typeof this.target_recipe_separate[deck_key] === "undefined") {
        this.target_recipe_separate[deck_key] = [];
      }

      this.target_recipe_separate[deck_key].push(tmp);

      this.target_recipe.push(tmp);

      this.recipeCnt();
      this.showSnackbar("《" + item.name + "》を追加しました！");
    },

    //---------------------------
    // レシピからカード削除
    //---------------------------
    delRecipeCard(item) {
      var items = [];
      var items2 = {};
      var deck_key = "";
      const deck_key_array = ["nomal", "ex"];

      // メインデッキとEXデッキを分けた配列更新
      for (var i = 0; i < deck_key_array.length; i++) {
        if (
          typeof this.target_recipe_separate[deck_key_array[i]] === "undefined"
        ) {
          continue;
        }
        this.target_recipe_separate[deck_key_array[i]].forEach(value => {
          if (value.id != item.id) {
            if (value["monster_type2"] == "フュージョン") {
              deck_key = "ex";
            } else {
              deck_key = "nomal";
            }
            if (typeof items2[deck_key] === "undefined") {
              items2[deck_key] = [];
            }
            items2[deck_key].push(value);
          }
        });
      }
      this.target_recipe_separate = items2;

      // 両方混ぜた配列更新
      this.target_recipe.forEach(value => {
        if (value.id != item.id) {
          items.push(value);
        }
      });
      this.target_recipe = items;

      this.recipeCnt();

      this.showSnackbar("《" + item.card_name + "》を削除しました！");
    },

    //---------------------------
    // カード枚数カウント
    //---------------------------
    recipeCnt() {
      this.target_all_card = 0;
      this.target_mon_card = 0;
      this.target_mag_card = 0;
      this.target_tra_card = 0;
      this.target_leg_card = 0;
      this.target_ex_card = 0;

      // ノーマルデッキ
      if (typeof this.target_recipe_separate["nomal"] != "undefined") {
        this.target_recipe_separate["nomal"].forEach(value => {
          // console.log(value);
          if (value.attr == "魔法") {
            this.target_mag_card++;
          } else if (value.attr == "罠") {
            this.target_tra_card++;
          } else if (value.monster_type2 != "フュージョン") {
            this.target_mon_card++;
          }
          if (value.legend == "LEGEND") {
            this.target_leg_card++;
          }
          if (value.monster_type2 == "フュージョン") {
            this.target_ex_card++;
          } else {
            this.target_all_card++;
          }
        });
      }

      // エクストラデッキ
      if (typeof this.target_recipe_separate["ex"] != "undefined") {
        this.target_recipe_separate["ex"].forEach(value => {
          if (value.legend == "LEGEND") {
            this.target_leg_card++;
          }
          if (value.monster_type2 == "フュージョン") {
            this.target_ex_card++;
          } else {
            this.target_all_card++;
          }
        });
      }
    },

    //---------------------------
    // デッキレシピ更新
    //---------------------------
    saveRecipe(edit_type) {
      if (edit_type == "delete") {
        this.target_post_type2 = edit_type;
      }

      var msg = "";
      var r_name = "";
      if (this.target_post_type2 == "insert") {
        msg = "新規登録";
        r_name = this.edit_deck_recipe_name;
      } else if (this.target_post_type2 == "update") {
        msg = "更新";
        r_name = this.edit_deck_recipe_name;
      } else if (this.target_post_type2 == "delete") {
        msg = "削除";
        r_name = this.befor_recipe_name;
      } else {
        alert("予期せぬエラーが発生しました。error code: post_type is empty");
        return;
      }

      if (
        !window.confirm(
          "《" + r_name + "》を" + msg + "します。よろしいですか？"
        )
      ) {
        return;
      }

      this.loading = true;

      var item = {
        id: this.target_item.id,
        befor_recipe_name: this.befor_recipe_name,
        update_recipe_name: this.edit_deck_recipe_name,
        deck_recipe: this.target_recipe_separate,
        post_type: this.target_post_type2,
        default_deck_edit_flg: this.target_default_deck_edit_flg
      };

      console.log(item);

      axios
        .post(process.env.VUE_APP_RD_DECK_RECIPE_UPDATE, {
          data: item
        })

        .then(response => {
          console.log(response.data);
          alert("《" + r_name + "》を" + msg + "しました！");
          this.showDialog = false;
        })
        .catch(error => {
          alert(
            "《" +
              r_name +
              "》の" +
              msg +
              "に失敗しました。\nエンジニアまでご連絡ください。\nerror code: " +
              error
          );
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
          this.showDialog2 = false;
          this.getDeckRecipeNameList(item);
          this.getDeckRecipeList();
          this.recipeCnt();
          this.showDialog = true;
        });
    },

    //---------------------------
    // クリップボードにURL等をコピー
    //---------------------------
    copyToClipboard(item, type) {
      event.stopPropagation();
      var text = "";
      if (type == "img") {
        text =
          "<a href='" +
          item.url +
          "'><img class='aligncenter' src='https://appmedia.jp" +
          item.img +
          "' alt='デュエルリンクス_" +
          item.name +
          "デッキ' width='60' height='87' loading='lazy'>" +
          item.name +
          "</a>";
      } else {
        text = "《<a href='" + item.url + "'>" + item.name + "</a>》";
      }

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);

      var msg = "";
      if (type == "img") {
        msg = "画像付きリンクをコピーしました！";
      } else {
        msg = "画像なしリンクをコピーしました！";
      }

      this.showSnackbar("《" + item.name + "》の" + msg);
    },

    copyToClipboard2(item) {
      // console.log(item);
      event.stopPropagation();
      var text =
        "[yugioh_rd_sc article='deck_info1' id='" +
        item.id +
        "' name='" +
        item.disp_recipe_name +
        "']";

      var copyTextarea = document.createElement("textarea");
      copyTextarea.style.position = "fixed";
      copyTextarea.style.opacity = "0";
      copyTextarea.textContent = text;

      document.body.appendChild(copyTextarea);
      copyTextarea.select();
      document.execCommand("copy");
      document.body.removeChild(copyTextarea);

      this.showSnackbar(
        "《" +
          item.name +
          "》(" +
          item.disp_recipe_name +
          ")のショートコードをコピーしました！"
      );
    },

    //---------------------------
    // ダイアログ閉じ
    //---------------------------
    closeDialog() {
      this.showDialog = false;
    },
    closeDialog2() {
      this.showDialog2 = false;
    }
  },

  watch: {},

  beforeCreate: function() {}
};
</script>

<style>
.deck_tab {
  height: 50vh;
}

/* メイン、エクストラデッキ_S */
.deck_list2 {
  display: flex;
  flex-wrap: wrap;
}
.deck_list2 li {
  display: inline-block;
  text-align: center;
  font-size: 11px;
  line-height: 1.2;
  margin-bottom: 2px;
  margin-top: 2px;
}
.deck_list2 li .card_name2 {
  margin-top: 2px;
  width: 90px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 10px;
  font-weight: bold;
}
/* メイン、エクストラデッキ_E */

/* レシピ名_編集用 */
.label_small .v-label {
  font-size: 14px;
}
/* カードカウンタ */
.card_cnt_lbl {
  font-size: 15px;
}
/* カードカウンタ_EX */
.card_cnt_lbl_ex {
  background-color: #5e35b1;
  font-size: 15px;
  color: #fff;
  padding: 3px 1px;
  font-weight: bold;
  border: 1px solid #5e35b1;
}
/* 注意書き */
.remarks_txt {
  font-size: 12px;
}

.deck_limit {
  border: 2px solid #ff0000;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  background-color: #222;
  color: #ffff00;
  font-weight: bold;
  display: inline-block;
  text-align: center;
  font-size: 13px;
  margin-right: 2px;
  position: absolute;
  top: 0px;
  left: 0px;
}
</style>
